<template>
    <div class="modal fade" :class="{'is-open': open}">
        <div class="modal-dialog">
            <div v-if="open" class="modal-content" :class="{'section-loading': isDataLoading}">
                <div class="modal-header">
                    <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
                    <h3 class="modal-title">客戶通聯資料</h3>
                </div>
                <div class="modal-body">
                    <table class="table insurance-green">
                        <tr>
                            <th class="text-green text-right" width="14%">類別</th>
                            <th class="text-green" width="21%">項目</th>
                            <th class="text-green" width="40%">內容</th>
                            <th class="text-green" width="25%">更新時間</th>
                        </tr>
                        <tr>
                            <th class="text-green text-right">手機號碼</th>
                            <td>手機號碼</td>
                            <td>{{infoDetail.mobl_no}}</td>
                            <td>{{infoDetail.mobile_update_date | dateToROCdateFormat}}<br>{{infoDetail.mobile_update_time}}</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="3">電話號碼</th>
                            <td>住家電話號碼</td>
                            <td>{{infoDetail.htel_bundle}}</td>
                            <td>{{infoDetail.tel_h_update_date | dateToROCdateFormat}}<br>{{infoDetail.tel_h_update_time}}</td>
                        </tr>
                        <tr>
                            <td>公司電話號碼</td>
                            <td>{{infoDetail.ctel_bundle}}</td>
                            <td>{{infoDetail.tel_o_update_date | dateToROCdateFormat}}<br>{{infoDetail.tel_o_update_time}}</td>
                        </tr>
                        <tr>
                            <td>聯絡電話號碼</td>
                            <td>{{infoDetail.tel_p_bundle}}</td>
                            <td>{{infoDetail.tel_p_update_date | dateToROCdateFormat}}<br>{{infoDetail.tel_p_update_time}}</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="3">地址</th>
                            <td>收費地址</td>
                            <td>{{infoDetail.addr_p_postal_cd}}{{infoDetail.addr_p_city_nm}}{{infoDetail.addr_p_line_1}}{{infoDetail.addr_p_line_2}}</td>
                            <td>{{infoDetail.addr_p_update_date | dateToROCdateFormat}}<br>{{infoDetail.addr_p_update_time}}</td>
                        </tr>
                        <tr>
                            <td>戶籍地址</td>
                            <td>{{infoDetail.addr_h_postal_cd}}{{infoDetail.addr_h_city_nm}}{{infoDetail.addr_h_line_1}}{{infoDetail.addr_h_line_2}}</td>
                            <td>{{infoDetail.addr_h_update_date | dateToROCdateFormat}}<br>{{infoDetail.addr_h_update_time}}</td>
                        </tr>
                        <tr>
                            <td>聯絡地址</td>
                            <td>{{infoDetail.addr_c_postal_cd}}{{infoDetail.addr_c_city_nm}}{{infoDetail.addr_c_line_1}}{{infoDetail.addr_c_line_2}}</td>
                            <td>{{infoDetail.addr_c_update_date | dateToROCdateFormat}}<br>{{infoDetail.addr_c_update_time}}</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="4">email</th>
                            <td>email</td>
                            <td>{{infoDetail.email}}</td>
                            <td>{{infoDetail.email_update_date | dateToROCdateFormat}}<br>{{infoDetail.email_update_time}}</td>
                        </tr>
                    </table>
                    <p>資料來源依據單一資料庫，僅供查詢聯繫保戶使用，如資料有誤，請填聯繫單或A4變更申請書修正</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConnectDataModal',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        detailData: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            isDataLoading: false,
            infoDetail: {},
            bundlePhoneTarget: ['htel', 'ctel'],
            bundleTimeTarget: ['addr_p', 'addr_h', 'addr_c', 'addr_newest', 'email']
        }
    },
    watch: {
        'detailData' : 'syncDataFromSuperComponent',
        'loading' : 'syncDataFromSuperComponent'
    },
    methods: {
        syncDataFromSuperComponent() {
            this.isDataLoading = this.loading
            this.infoDetail = this.detailData
            let $this = this
            if(Object.keys(this.infoDetail).length > 0) {
                this.bundlePhoneTarget.forEach(function(target){$this.bundlePhone(target)})
                this.bundleTimeTarget.forEach(function(target){$this.bundleTime(target)})
            }
        },
        bundlePhone(key) {
            let tag1 = ''
            let tag2 = ''
            let area = this.infoDetail[key + '_area'] || "";
            let num = this.infoDetail[key + '_num'] || "";
            let ext = this.infoDetail[key + '_ext'] || "";
            if(area && num) {
                tag1 = '-'
            }
            if(ext) {
                tag2 = '#'
            }
            this.infoDetail[key + '_bundle'] = area + tag1 + num + tag2 + ext
        },
        bundleTime(key) {
            let timeWithDate = this.infoDetail[key + '_update']
            let date = ''
            let time = ''
            if(timeWithDate) {
                date = timeWithDate.slice(0, 10)
                time = timeWithDate.slice(11, timeWithDate.length)
            }
            this.infoDetail[key + '_update_date'] = date
            this.infoDetail[key + '_update_time'] = time
        }
    }
}
</script>
<style>
</style>
